import { useWSModal } from "@wingspanhq/fe-component-library";
import { W9Consent } from "./index";

export const useModalFormW9Consent = () =>
  useWSModal(W9Consent, {
    size: "S"
  });
